import { Component, EventEmitter, OnDestroy, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { GtwElementsBaseUrlsModel } from '../../../../app/shared/_models/gtw-elements-base-urls.model';
import { FgnF5471H1ComponentService } from './fgn-f5471-h1.service';
import { Subscription } from 'rxjs';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { GtwSnackbarService } from '../../../shared/_services/gtw-snackbar.service';
import { GlobalService } from '../../../global/services/global.service';
import { WorkspaceService } from '../../../workspace/workspace.service';
import { AppService } from '../../../app.service';
import {
  extractObject,
  generalConfigFromGlobal,
  hydratedGlobalParams,
  normalizeFilterParams,
  rowPayloadFromActiveScreen
} from '../../../shared/workspace-element-context';

@Component({
    selector: 'gtw-fgn-f5471-h1',
    templateUrl: './fgn-f5471-h1.component.html',
    styleUrls: ['./fgn-f5471-h1.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class FgnF5471H1Component implements OnInit, OnDestroy {

  baseGlobalParams: any = {};
  baseURLs: GtwElementsBaseUrlsModel = {
    admin: '',
    api: '/gtw',
    custom: '',
    efile: '',
    pdfEngine: '',
    bulkPdfEngine: ''
  };

  private ssoId = '';
  private checkLockedObj: any = [];
  private rowData: any = {};
  private modalName = '';
  private filterParams: any = {};
  isViewOnly = false;
  enableButton = true;
  firf5471h1form!: UntypedFormGroup;
  con_fin_stmt_amt = 0;
  con_fin_stmt_comment = '';
  con_rtn_amt = 0;
  con_rtn_comment = '';
  oth_adj_amt = 0;
  oth_adj_comment = '';
  cfc_pship_dre_val = '';
  con_fin_stmt_flg = false;
  con_rtn_flg = false;
  oth_adj_flg = false;
  validData = true;
  title = '5471 H-1 Worksheet';
  clob_settings: { tax_year: number; scenario: number; jcd_key: number } = {
    tax_year: 0,
    scenario: 0,
    jcd_key: 0
  };
  clob_data: any = [];

  @Output('request-grid-update') requestGridUpdate = new EventEmitter<any>();

  @Output('close-firf5471h1confirm-info')
  closefirf5471h1confirmInfo = new EventEmitter<string>();

  @Output('save-firf5471h1save-info')
  savefirf5471h1Info = new EventEmitter<string>();

  subscriptions = new Subscription();

  constructor(
    private FgnF5471H1ComponentService: FgnF5471H1ComponentService,
    private alertService: GtwSnackbarService,
    private gtwGlobal: GlobalService,
    private gtwWorkspace: WorkspaceService,
    private gtwApp: AppService
  ) {
    this.firf5471h1form = new UntypedFormGroup({
      confinstmtcmt: new UntypedFormControl(),
      confinstmtamt: new UntypedFormControl(),
      conrtnamt: new UntypedFormControl(),
      conrtncmt: new UntypedFormControl(),
      othadjamt: new UntypedFormControl(),
      othadjcmt: new UntypedFormControl()
    });
  }

  ngOnInit(): void {
    this.applyWorkspaceContext();
    this.init();
    this.subscriptions.add(
      this.gtwWorkspace.setTabActive.subscribe(() => {
        this.applyWorkspaceContext();
        this.init();
      })
    );
    this.subscriptions.add(
      this.gtwGlobal.globalParamsChanged$.subscribe(() => {
        this.applyWorkspaceContext();
        this.init();
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  private applyWorkspaceContext(): void {
    const activeScreen = this.gtwWorkspace.workspaceFactory?.activeScreen || {};
    const gc = generalConfigFromGlobal(this.gtwGlobal) as GtwElementsBaseUrlsModel;
    const apiRoot = gc.api || (gc as any).base_url || '';
    this.baseURLs = { ...gc, api: apiRoot || gc.api || '/gtw' };
    this.baseGlobalParams = hydratedGlobalParams(this.gtwGlobal, this.gtwWorkspace) || {};
    this.filterParams = normalizeFilterParams(activeScreen) || {};
    this.checkLockedObj = this.baseGlobalParams?.checkLockedbj ?? this.checkLockedObj;

    const rawRow = rowPayloadFromActiveScreen(activeScreen);
    this.rowData = Array.isArray(rawRow)
      ? extractObject(rawRow[0]?.data ?? rawRow[0])
      : extractObject(rawRow);

    this.modalName = activeScreen?.data?.modal_name
      || activeScreen?.data?.modalName
      || this.baseGlobalParams?.modalScreen?.modal_name
      || this.modalName;
    const sso = this.gtwApp?.USER_SETTINGS?.user?.sso_id;
    this.ssoId = sso != null && sso !== '' ? String(sso) : this.ssoId;
  }

  checkInputType(): boolean {
    if (
      Number.isInteger(parseInt(this.ssoId + '', 10)) &&
      Object.keys(extractObject(this.rowData)).length > 0 &&
      this.modalName != null &&
      this.modalName !== '{{ctrl.modalName}}' &&
      Object.keys(extractObject(this.filterParams)).length > 0
    ) {
      return true;
    }
    return false;
  }

  init(): void {
    if (this.checkInputType()) {
      if (
        this.modalName === 'conFinStmtCFC' ||
        this.modalName === 'conFinStmtPSHIP' ||
        this.modalName === 'conFinStmtDRE'
      ) {
        this.con_fin_stmt_flg = true;
        this.con_fin_stmt_amt = this.rowData.CON_FIN_STMT == null ? 0 : this.rowData.CON_FIN_STMT;
        this.con_fin_stmt_comment =
          this.rowData.CON_FIN_STMT_CMMENTS == null ? '' : this.rowData.CON_FIN_STMT_CMMENTS;
      } else if (
        this.modalName === 'conRtnCFC' ||
        this.modalName === 'conRtnPSHIP' ||
        this.modalName === 'conRtnDRE'
      ) {
        this.con_rtn_flg = true;
        this.con_rtn_amt = this.rowData.CON_RTN == null ? 0 : this.rowData.CON_RTN;
        this.con_rtn_comment = this.rowData.CON_RTN_CMMENTS == null ? '' : this.rowData.CON_RTN_CMMENTS;
      } else if (
        this.modalName === 'othAdjCFC' ||
        this.modalName === 'othAdjPSHIP' ||
        this.modalName === 'othAdjDRE'
      ) {
        this.oth_adj_flg = true;
        this.oth_adj_amt = this.rowData.OTH_ADJ == null ? 0 : this.rowData.OTH_ADJ;
        this.oth_adj_comment = this.rowData.OTH_ADJ_CMMENTS == null ? '' : this.rowData.OTH_ADJ_CMMENTS;
      }
    }
  }

  save(): void {
    this.clob_data = [];
    this.validData = true;
    if (this.con_fin_stmt_flg && this.con_fin_stmt_amt != 0 && this.con_fin_stmt_comment === '') {
      this.validData = false;
      this.alertService.openSnackBar('Please enter the comments. ', 'gtw-snackbar--red');
    }
    if (this.con_fin_stmt_flg && isNaN(+this.con_fin_stmt_amt)) {
      this.validData = false;
      this.alertService.openSnackBar('Please enter numeric value for amount field. ', 'gtw-snackbar--red');
    }

    if (this.con_rtn_flg && this.con_rtn_amt != 0 && this.con_rtn_comment === '') {
      this.validData = false;
      this.alertService.openSnackBar('Please enter the comments. ', 'gtw-snackbar--red');
    }

    if (this.con_rtn_flg && isNaN(+this.con_rtn_amt)) {
      this.validData = false;
      this.alertService.openSnackBar('Please enter numeric value for amount field. ', 'gtw-snackbar--red');
    }

    if (this.oth_adj_flg && this.oth_adj_amt != 0 && this.oth_adj_comment === '') {
      this.validData = false;
      this.alertService.openSnackBar('Please enter the comments. ', 'gtw-snackbar--red');
    }

    if (this.oth_adj_flg && isNaN(+this.oth_adj_amt)) {
      this.validData = false;
      this.alertService.openSnackBar('Please enter numeric value for amount field. ', 'gtw-snackbar--red');
    }
    if (this.validData) {
      this.enableButton = false;
      if (
        this.modalName === 'conFinStmtCFC' ||
        this.modalName === 'conRtnCFC' ||
        this.modalName === 'othAdjCFC'
      ) {
        this.cfc_pship_dre_val = 'CFC';
      } else if (
        this.modalName === 'conFinStmtPSHIP' ||
        this.modalName === 'conRtnPSHIP' ||
        this.modalName === 'othAdjPSHIP'
      ) {
        this.cfc_pship_dre_val = 'PSHIP';
      } else if (
        this.modalName === 'conFinStmtDRE' ||
        this.modalName === 'conRtnDRE' ||
        this.modalName === 'othAdjDRE'
      ) {
        this.cfc_pship_dre_val = 'DRE';
      } else {
        this.cfc_pship_dre_val = '';
      }

      if (this.con_fin_stmt_flg) {
        const tempObj = {
          COMBINATION_KEY: this.rowData.COMBINATION_KEY,
          CON_FIN_STMT_FLG: this.con_fin_stmt_flg ? 'Y' : 'N',
          CON_RTN_FLG: this.con_rtn_flg ? 'Y' : 'N',
          OTH_ADJ_FLG: this.oth_adj_flg ? 'Y' : 'N',
          CFC_PSHIP_DRE_VAL: this.cfc_pship_dre_val,
          AMOUNT: this.con_fin_stmt_amt,
          COMMENTS: this.con_fin_stmt_comment,
          TRANS_HEADER_KEY: this.rowData.CON_FIN_THK === undefined ? 0 : this.rowData.CON_FIN_THK,
          TRANS_DETAILS_KEY: this.rowData.CON_FIN_TDK === undefined ? 0 : this.rowData.CON_FIN_TDK
        };
        this.clob_data.push(tempObj);
      }
      if (this.con_rtn_flg) {
        const tempObjconRtn = {
          COMBINATION_KEY: this.rowData.COMBINATION_KEY,
          CON_FIN_STMT_FLG: this.con_fin_stmt_flg ? 'Y' : 'N',
          CON_RTN_FLG: this.con_rtn_flg ? 'Y' : 'N',
          OTH_ADJ_FLG: this.oth_adj_flg ? 'Y' : 'N',
          CFC_PSHIP_DRE_VAL: this.cfc_pship_dre_val,
          AMOUNT: this.con_rtn_amt,
          COMMENTS: this.con_rtn_comment,
          TRANS_HEADER_KEY: this.rowData.CON_RTN_THK === undefined ? 0 : this.rowData.CON_RTN_THK,
          TRANS_DETAILS_KEY: this.rowData.CON_RTN_TDK === undefined ? 0 : this.rowData.CON_RTN_TDK
        };
        this.clob_data.push(tempObjconRtn);
      }
      if (this.oth_adj_flg) {
        const tempObjOthAdj = {
          COMBINATION_KEY: this.rowData.COMBINATION_KEY,
          CON_FIN_STMT_FLG: this.con_fin_stmt_flg ? 'Y' : 'N',
          CON_RTN_FLG: this.con_rtn_flg ? 'Y' : 'N',
          OTH_ADJ_FLG: this.oth_adj_flg ? 'Y' : 'N',
          CFC_PSHIP_DRE_VAL: this.cfc_pship_dre_val,
          AMOUNT: this.oth_adj_amt,
          COMMENTS: this.oth_adj_comment,
          TRANS_HEADER_KEY: this.rowData.OTH_ADJ_THK === undefined ? 0 : this.rowData.OTH_ADJ_THK,
          TRANS_DETAILS_KEY: this.rowData.OTH_ADJ_TDK === undefined ? 0 : this.rowData.OTH_ADJ_TDK
        };
        this.clob_data.push(tempObjOthAdj);
      }
      this.clob_settings.tax_year = this.filterParams.tax_year;
      this.clob_settings.scenario = this.filterParams.scenario;
      this.clob_settings.jcd_key = this.baseGlobalParams.jcd_key;
      this.subscriptions.add(
        this.FgnF5471H1ComponentService.saveData(
          this.baseURLs.api,
          this.clob_data,
          this.clob_settings,
          this.baseGlobalParams,
          this.checkLockedObj,
          this.filterParams,
          this.ssoId
        ).subscribe(
          data => {
            if (data.callSuccess == '1') {
              this.FgnF5471H1ComponentService.openSnackBar('Data Saved Successfully', 'gtw-snackbar--green');
              this.savefirf5471h1Info.emit('save-firf5471h1save-info');
              this.requestGridUpdate.emit('refresh');
            } else {
              this.FgnF5471H1ComponentService.openSnackBar(
                'Error Saving Data. ' + data.errorMessage,
                'gtw-snackbar--red'
              );
            }
          },
          () => {
            console.log('Error while saving');
          }
        )
      );
    }
  }

  cancel(): void {
    this.closefirf5471h1confirmInfo.emit('close-firf5471h1confirm-info');
    this.requestGridUpdate.emit('cancel');
  }
}
